module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADQSURBVHgB7ZThDYIwEIVfDQOwgboBI+AE6gQ6ghuIE9QVnARGcANGoBvUd6EmDdYYkvYHsV/ycuUovHLtAWT+AmvthuqpNWLDl5ZiEDBrEIEikDtTJxrsGEuqpR5KqcZbRM1Q4zcdn+v8xGo6gxPuDIbSIbMkuDK21AVLR4WS/LIK4/4JhiV9IhU009TgTmbvxlekwo5U3nUlCUSi+JIfvLGZ3ozaFqn5ODSyZww36n1Q9tSBK90iAqGSyh9GOyNBSnrEUsl9mPtwNrkPM7N5AdexplEmvU71AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ico-poll.png
// module id = 1724
// module chunks = 1